// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permissions-confirmation{display:-ms-flexbox;display:flex}.permissions-confirmation .confirmation-checkbox{padding:0;height:22px;margin:0 10px 0 0}.permissions-confirmation label{padding-top:2px;font-family:\"GothamSSm-Medium\",Arial,sans-serif;font-size:14px;color:#a9a9a9;line-height:normal}\n", ""]);
// Exports
module.exports = exports;
